export const SET_CHOSEN_BANK = "SET_CHOSEN_BANK";
export const SET_BANK_DATA = "SET_BANK DATA";
export const SET_BANK_LEFT_TAB= "SET_BANK_LEFT_TAB";
export const SET_BANK_RIGHT_TAB= "SET_BANK_RIGHT_TAB";

export const SET_BANK_STEP= "SET_BANK_STEP";

